import ApiClient from './ApiClient';

class TiktokPixelsAPI extends ApiClient {
  constructor() {
    super('tiktok_pixels', { accountScoped: true });
  }
}

export default new TiktokPixelsAPI();
